import { z } from "zod";

export const cupNewsCardSchema = z.object({
	id: z.string().transform((id) => parseInt(id)),
	name: z.string(),
	mini_pic: z.string(),
});

export type cupNewsCardType = z.infer<typeof cupNewsCardSchema>;
